import React from 'react';
import { useTranslation } from 'react-i18next';
import { Regions } from '../../hooks/useConfiguration';

export const Disclaimer: React.FC<{
  region: Regions;
}> = ({ region }) => {
  const { t: tRegion } = useTranslation(region);
  const { t } = useTranslation();
  return (
    <>
      <h2>{t('imprint.disclaimer.title')}</h2>

      <h3>{t('imprint.disclaimer.liabilityForContent.title')}</h3>
      <p>{tRegion('imprint.disclaimer.liabilityForContent.text')}</p>

      <h3>{t('imprint.disclaimer.copyright.title')}</h3>
      <p>{tRegion('imprint.disclaimer.copyright.text')}</p>

      <h3>{t('imprint.disclaimer.patents.title')}</h3>
      <p>{tRegion('imprint.disclaimer.patents.text')}</p>
    </>
  );
};
